// extracted by mini-css-extract-plugin
module.exports = {"navHeight":"4.5rem","title":"home_title__13xbD","home-button":"home_home-button__2jM3M"};